import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CalendarComponent } from '../../calendar/calendar';

export interface SavingPlanItem {
    id: string;
    goalName: string;
    savedAmount: string;
    targetAmount: string;
    percentage: number;
    isPinned: boolean;
    icon: string;
}

@Component({
    selector: 'app-saving-plans-modal',
    standalone: true,
    imports: [CommonModule, FormsModule, CalendarComponent],
    templateUrl: './saving-plans-modal.html',
    styleUrl: './saving-plans-modal.scss'
})
export class SavingPlansModalComponent implements OnInit {
    @Input() isOpen: boolean = false;
    @Output() close = new EventEmitter<void>();

    savingPlans: SavingPlanItem[] = [
        {
            id: '1',
            goalName: 'Retirement',
            savedAmount: '₹5,505,000.35',
            targetAmount: '₹700,425.35',
            percentage: 70,
            isPinned: true,
            icon: 'assets/icons/target-05.svg'
        },
        {
            id: '2',
            goalName: 'Retirement',
            savedAmount: '₹5,505,000.35',
            targetAmount: '₹700,425.35',
            percentage: 60,
            isPinned: true,
            icon: 'assets/icons/target-05.svg'
        }
    ];

    isAddGoalOpen: boolean = false;
    isLoading: boolean = false;
    isCalendarOpen: boolean = false;

    // Form fields
    newGoalName: string = '';
    newGoalBudget: string = '';
    paymentDebitDate: string = '';

    // Validation errors
    errors: { [key: string]: string } = {};

    months: string[] = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    constructor() { }

    ngOnInit() {
        this.paymentDebitDate = this.formatDate(new Date());
    }

    onClose() {
        if (this.isAddGoalOpen) {
            this.isAddGoalOpen = false;
        } else {
            this.close.emit();
        }
    }

    togglePin(item: SavingPlanItem) {
        item.isPinned = !item.isPinned;
    }

    onEdit(item: SavingPlanItem) {

    }

    onAddNewGoal() {
        this.isAddGoalOpen = true;
        this.resetForm();
    }

    private resetForm() {
        this.newGoalName = '';
        this.newGoalBudget = '';
        this.paymentDebitDate = this.formatDate(new Date());
        this.errors = {};
    }

    onSaveGoal() {
        this.errors = {};
        let hasError = false;

        if (!this.newGoalName.trim()) {
            this.errors['name'] = 'Goal name is required';
            hasError = true;
        }

        if (!this.newGoalBudget || isNaN(Number(this.newGoalBudget.replace(/,/g, '')))) {
            this.errors['budget'] = 'Please enter a valid budget amount';
            hasError = true;
        } else if (Number(this.newGoalBudget.replace(/,/g, '')) <= 0) {
            this.errors['budget'] = 'Budget must be greater than 0';
            hasError = true;
        }

        if (hasError) {
            this.errors = { ...this.errors };
            return;
        }


        this.isAddGoalOpen = false;
    }

    toggleCalendar() {
        this.isCalendarOpen = !this.isCalendarOpen;
    }

    onDateSelect(date: Date) {
        this.paymentDebitDate = this.formatDate(date);
        this.isCalendarOpen = false;
    }

    private formatDate(date: Date): string {
        const day = date.getDate().toString().padStart(2, '0');
        const month = this.months[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    }

    private parseDate(dateStr: string): Date {
        const parts = dateStr.split(' ');
        if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const monthName = parts[1];
            const year = parseInt(parts[2]);
            const monthIndex = this.months.indexOf(monthName);
            if (monthIndex !== -1) {
                return new Date(year, monthIndex, day);
            }
        }
        return new Date(dateStr) || new Date();
    }

    getSelectedDate(): Date {
        return this.parseDate(this.paymentDebitDate);
    }
}
